import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { useAuthState } from '../../hooks/useAuthState'
import { useCurrentSubscriptionSWR } from '../useCurrentSubscriptionSWR'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import { useMemo } from 'react'

export interface ReverseTrialState {
  isLoading: boolean
  enabled?: boolean
  inTrial?: boolean
  /** Plan type the user is currently trialing */
  planType?: PlanType
}

const LOADING_STATE: ReverseTrialState = { isLoading: true }

export function useReverseTrialState(): ReverseTrialState {
  const authState = useAuthState()
  const currentSubscriptionSWR = useCurrentSubscriptionSWR(
    {},
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true
    }
  )
  const [reverseTrialEnabled] = useFlowFeature('reverse_trial')
  const state = useMemo<ReverseTrialState>(() => {
    if (!authState.isAuthChecked) return LOADING_STATE
    if (currentSubscriptionSWR.isValidating) return LOADING_STATE
    const enabled = reverseTrialEnabled
    const inTrial = Boolean(currentSubscriptionSWR.data?.trialEndAt)
    return {
      isLoading: false,
      enabled,
      inTrial,
      ...(inTrial ? { planType: currentSubscriptionSWR.data?.plan.type } : {})
    }
  }, [
    authState.isAuthChecked,
    currentSubscriptionSWR.data?.trialEndAt,
    currentSubscriptionSWR.isValidating,
    currentSubscriptionSWR.data?.plan.type,
    reverseTrialEnabled
  ])
  return state
}
